import {SkeletonText} from '@primer/react/experimental'
import {Spinner} from '@primer/react'
import styles from '../PulseSummary.module.css'
import {clsx} from 'clsx'

export const SkeletonLoaderSummary = () => (
  <div className={styles.text}>
    <div>
      <div>
        <SkeletonText />
        <SkeletonText />
      </div>
    </div>
    <div>
      <div>
        <SkeletonText />
        <SkeletonText />
      </div>
    </div>
  </div>
)

export const SkeletonLoaderChart = () => (
  <div className={clsx(styles.summaryBox, `d-flex flex-items-center flex-justify-center`)}>
    <Spinner />
  </div>
)

try{ SkeletonLoaderSummary.displayName ||= 'SkeletonLoaderSummary' } catch {}
try{ SkeletonLoaderChart.displayName ||= 'SkeletonLoaderChart' } catch {}